import { createApp } from "vue";
import "./style.css";
import App from "./App.vue";
import router from "./config/router";
import { AuthService } from "./services/authService";
import { isSignInWithEmailLink } from "firebase/auth";
import { auth } from "./config/firebase";

// Make router available globally for AuthService
window.router = router;

// Detect test mode from URL
const urlParams = new URLSearchParams(window.location.search);
window.__SURVEY_TEST_MODE__ = urlParams.get("test") === "true";

// Prevent zoom via keyboard shortcuts
document.addEventListener(
  "keydown",
  function (e) {
    if (
      (e.ctrlKey || e.metaKey) &&
      (e.key === "+" ||
        e.key === "-" ||
        e.key === "=" ||
        e.key === "0" ||
        e.key === "_")
    ) {
      e.preventDefault();
    }
  },
  { passive: false }
);

// Prevent zoom via mouse wheel + Ctrl/Cmd
document.addEventListener(
  "wheel",
  function (e) {
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault();
    }
  },
  { passive: false }
);

// Prevent pinch-to-zoom on touch devices
document.addEventListener(
  "touchmove",
  function (e) {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  },
  { passive: false }
);

// Handle email link authentication before app initialization
// This prevents the router guard from blocking access when users return from email links
const initializeAuth = async () => {
  // Check if this is an email link authentication
  if (isSignInWithEmailLink(auth, window.location.href)) {
    // Detect if the current route is an admin route
    // (no longer used for redirect logic)
    // const isAdminRoute =
    //   window.location.pathname.startsWith("/surveyadmin") ||
    //   window.location.pathname.startsWith("/survey-admin");
    // If already authenticated, do nothing
    if (auth.currentUser) return;
    // Always handle the email link, regardless of route
    try {
      const result = await AuthService.handleEmailLink();
      if (result.success) {
        console.log("Main: Email link authentication successful");
      } else {
        console.log("Main: Email link authentication failed:", result.message);
      }
    } catch (error) {
      console.error("Main: Error handling email link:", error);
    }
  }
};

// Initialize the app
const initApp = async () => {
  // Initialize authentication before creating the app
  await initializeAuth();

  createApp(App).use(router).mount("#app");
};

// Start the app
initApp();
